"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function updateModulesStudied(aggregatedStat, sessionEvent) {
    const { modules } = sessionEvent;
    return (aggregatedStat.sessionModulesStudied +
        modules.filter(module => module.sectionId === aggregatedStat.sectionId)
            .length);
}
exports.default = updateModulesStudied;
